// extracted by mini-css-extract-plugin
export var check = "howSendItSelector_check__FAtfI";
export var checkContainer = "howSendItSelector_checkContainer__Wrf8E";
export var container = "howSendItSelector_container__dDdut";